import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { Button, Drawer } from '@mui/material';
import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

// --- Helper type for custom prop
type StyledLinkProps = {
  $isBorder?: boolean;
};

export const StyledDrawer = styled(Drawer)({
  '.MuiDrawer-paper': {
    width: '100%',
    paddingBottom: 12,
  },
});

export const StyledMenuButton = styled(Button)({
  padding: 0,
  minWidth: 0,
});

export const StyledMenuIcon = styled(MenuIcon)({
  color: COLORS.textMain,
});

export const StyledContainer = styled('div')({
  padding: '0 16px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const StyledTop = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '0 -16px',
  padding: '0 16px 8px',
  borderBottom: `1px solid ${COLORS.grey200}`,
});

export const StyledLogo = styled('img')({
  width: 128,
});

export const StyledContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  flex: 1,
  paddingTop: 20,
});

export const StyledBottom = styled('div')({
  display: 'flex',
  marginTop: 'auto',
  flexDirection: 'column',
  gap: 12,
});

export const StyledBottomLink = styled(Link)({
  width: '100%',
  padding: '8px 20px',
  borderRadius: 20,
  fontSize: 18,
  lineHeight: '24px',
  fontWeight: 500,
  color: COLORS.white,
  backgroundColor: COLORS.primary,
  textDecoration: 'none',
  textAlign: 'center',
});

export const StyledBottomLinkLogin = styled(StyledBottomLink)({
  color: COLORS.primary,
  backgroundColor: COLORS.blue50,
});

export const StyledLinksWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
});

// --- Correct prop filtering and type safety
export const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== '$isBorder',
})<StyledLinkProps>(({ $isBorder }) => ({
  textDecoration: 'none',
  color: COLORS.textMain,
  fontSize: 16,
  lineHeight: '22px',
  borderBottom: $isBorder ? `1px solid ${COLORS.grey200}` : 'unset',
  paddingBottom: 12,
}));

export const StyledLanguageSwitcherContainer = styled('div')({
  display: 'flex',
  gap: 12,
  justifyContent: 'space-between',
});
